import { masIdsEqual } from './mas-ids';

/** Staff greeting of a parent for a single schedule/class session. */
export interface ScheduleGreeting {
	parentAccountId: string;
	userId: string;
	greetedAt: string;
}

export function hasScheduleGreeting(
	greetings: readonly ScheduleGreeting[] | null | undefined,
	parentAccountId: string,
	userId: string,
): boolean {
	return (greetings ?? []).some(
		row => masIdsEqual(row.parentAccountId, parentAccountId) && masIdsEqual(row.userId, userId),
	);
}

export function addScheduleGreeting(
	greetings: readonly ScheduleGreeting[] | null | undefined,
	parentAccountId: string,
	userId: string,
	greetedAt: string,
): { greetings: ScheduleGreeting[]; changed: boolean } {
	const current = greetings ?? [];
	if (hasScheduleGreeting(current, parentAccountId, userId)) {
		return { greetings: [...current], changed: false };
	}
	return {
		greetings: [...current, { parentAccountId, userId, greetedAt }],
		changed: true,
	};
}

export function removeScheduleGreeting(
	greetings: readonly ScheduleGreeting[] | null | undefined,
	parentAccountId: string,
	userId: string,
): { greetings: ScheduleGreeting[]; changed: boolean } {
	const current = greetings ?? [];
	const next = current.filter(
		row => !(masIdsEqual(row.parentAccountId, parentAccountId) && masIdsEqual(row.userId, userId)),
	);
	return {
		greetings: next,
		changed: next.length !== current.length,
	};
}
